<template>
    <div>
        <div class="head-container">
            <div>
                <div class="head-text-main">
                    ΣΧΕΤΙΚΑ ΜΕ ΤΟ NUTRISENSE
                </div>
            </div>
        </div>

        <v-container class="main-text text-container">
            <v-row>
                <v-col>
                    Το <span class="green-text"><span class="green-text">NUTRISENSE</span></span> είναι ένας τεχνοβλαστός του Γεωπονικού Πανεπιστημίου Αθηνών ο οποίος δημιουργήθηκε με στόχο να υποστηρίξει τους καλλιεργητές στην εφαρμογή οικονομικά βιώσιμων και φιλικών προς το περιβάλλον πρακτικών λίπανσης σε κηπευτικές καλλιέργειες. Για την επίτευξη αυτού του στόχου, η εταιρεία ανέπτυξε ένα νέο σύστημα υποστήριξης αποφάσεων το οποίο ονομάζεται <span class="green-text">NutriSense</span> και περιλαμβάνει δύο διακριτές εκδοχές, μια για καλλιέργειες εδάφους (<span class="green-text">SOIL NutriSense</span>) και μια για καλλιέργειες εκτός έδαφος (<span class="green-text">SOILLESS NutriSense</span>).
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    Το  <span class="green-text">SOIL NutriSense</span> είναι ένα φιλικό προς τον χρήστη σύστημα υποστήριξης αποφάσεων (DSS) το οποίο έχει δημιουργηθεί στο Γεωπονικό Πανεπιστήμιο Αθηνών από τον Καθηγητή Δημήτρη Σάββα και την ερευνητική του ομάδα στο Εργαστήριο Κηπευτικών Καλλιεργειών (ΕΚΚ). Το <span class="green-text">NUTRISENSE</span> είναι ένα ειδικό λογισμικό αποτελούμενο από εξειδικευμένους αλγορίθμους οι οποίοι βασίζονται σε νέες γνώσεις και καινοτόμες τεχνολογίες σχετικά τη λίπανση των καλλιεργειών. Το λογισμικό βασίζεται σε μια τεράστια βάση δεδομένων που προέρχεται κυρίως από αξιόπιστες διεθνείς βιβλιογραφικές πηγές αλλά και από πειραματικές εργασίες σχετικά με την λίπανση κηπευτικών καλλιεργειών οι οποίες έχουν διεξαχθεί στο Γεωπονικό Πανεπιστήμιο Αθηνών από την Ερευνητική Ομάδα του ΕΚΚ τα τελευταία 18 χρόνια. Το <span class="green-text">SOIL NutriSense</span> παρέχει στους χρήστες εξατομικευμένες συμβουλές σχετικά με τη λίπανση των καλλιεργειών μετά την εισαγωγή ορισμένων απαραίτητων πληροφοριών, όπως το είδος του καλλιεργούμενου φυτού, η εποχή του έτους, η χημική σύνθεση του νερού, καθώς και τα δεδομένα μίας εδαφολογικής ανάλυσης. Το SOIL <span class="green-text">NutriSense</span> μπορεί να δεχθεί δεδομένα ανάλυσης εδάφους προερχόμενα από διάφορα αναλυτικά πρωτοκόλλα ανάλυσης όσον αφορά τον τρόπο εκχύλισης (π.χ. υδατοδιαλυτά ή ανταλλάξιμα, εκχυλιστική ουσία, αναλογία ανάμειξης εδάφους με νερό). Επιπλέον, το SOIL <span class="green-text">NutriSense</span> μπορεί να δεχθεί και να αξιοποιήσει δεδομένα από άμεσες μετρήσεις της περιεκτικότητας θρεπτικών στοιχείων στο εδαφικό νερό με στόχο την διόρθωση του σχήματος λίπανσης κατά την περίοδο της καλλιέργειας. Δείγματα εδαφικού νερού μπορούν να λαμβάνονται με ειδικό εξοπλισμό μέσω μύζησής του απευθείας από το έδαφος.
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    Το <span class="green-text">SOILLESS NutriSense</span> είναι ένα εξειδικευμένο σύστημα υποστήριξης αποφάσεων (DSS) για τη διαχείριση της υδρολίπανσης σε υδροπονικές καλλιέργειες (καλλιέργειες εκτός εδάφους). Αυτή η εκδοχή του <span class="green-text">NutriSense</span> χρησιμοποιεί μια σειρά κατάλληλων αλγορίθμων που βασίζονται σε μαθηματικά προσομοιώματα για να παρέχει εξατομικευμένες συνθέσεις θρεπτικών διαλυμάτων για υδροπονικές καλλιέργειες τόσο σε ανοιχτά όσο και κλειστά συστήματα. Το SOILLESS <span class="green-text">NutriSense</span> χρησιμοποιεί δεδομένα που προέρχονται από διάφορες βιβλιογραφικές πηγές σχετικά με τις απαιτήσεις σε θρεπτικά συστατικά μιας μεγάλης ποικιλίας ειδών λαχανικών και καλλωπιστικών φυτών, τα οποία είναι διαθέσιμα σε μια βάση δεδομένων. Όταν το SOILLESS <span class="green-text">NutriSense</span> χρησιμοποιείται για τον υπολογισμό ενός θρεπτικού διαλύματος για μια συγκεκριμένη καλλιέργεια, οι συστάσεις που περιλαμβάνονται στη βάση δεδομένων προσαρμόζονται στα ειδικά χαρακτηριστικά και τις συνθήκες αυτής της καλλιέργειας και ιδιαίτερα στην χημική σύσταση του νερού που χρησιμοποιείται για την Παρασκευή των θρεπτικών διαλυμάτων. Πιο συγκεκριμένα, το SOILLESS <span class="green-text">NutriSense</span> λαμβάνει υπόψη τα ακόλουθα χαρακτηριστικά προκειμένου να καταρτίσει συνταγή θρεπτικού διαλύματος για μια καλλιέργεια:
                    <ul>
                        <li>είδος καλλιέργειας (καλλιεργούμενο φυτό, π.χ. τομάτα, αγγούρι, ζέρμπερα, κ.λπ.),</li>
                        <li>εποχή του έτους,</li>
                        <li>στάδιο ανάπτυξης του φυτού,</li>
                        <li>χημική σύνθεση του νερού άρδευσης που χρησιμοποιείται για την παρασκευή του θρεπτικού διαλύματος,</li>
                        <li>τρόπος διαχείρισης των απορροών (ανοιχτά ή κλειστά υδροπονικά συστήματα),</li>
                        <li>τύπος υδροπονικού συστήματος (καλλιέργεια σε υπόστρωμα, υδροκαλλιέργεια),</li>
                        <li>αριθμός και όγκος δεξαμενών με πυκνά διαλύματα λιπασμάτων,</li>
                        <li>διαθέσιμα ή προτιμώμενα λιπάσματα</li>
                    </ul>
                    Επιπλέον, το <span class="green-text">SOILLESS NutriSense</span> χρησιμοποιείται για την τακτική αναπροσαρμογή της σύνθεσης του παρεχόμενου θρεπτικού διαλύματος κατά την περίοδο καλλιέργειας, μετά από χημική ανάλυση δείγματος διαλύματος απορροής.
                    <br><br>
                    Το <span class="green-text">NUTRISENSE</span> είναι ένα συμβουλευτικό εργαλείο που παρέχει στους παραγωγούς μια πρακτική και αποτελεσματική μεθοδολογία διαχείρισης της λίπανσης και της θρέψης των καλλιεργειών τους.  Με την χρήση του <span class="green-text">NUTRISENSE</span> οι παραγωγοί μπορούν να βελτιώσουν τόσο το ύψος της παραγωγής όσο και την ποιότητα των προϊόντων τους, ενώ παράλληλα μειώνουν το κόστος και ελαχιστοποιούν τις περιβαλλοντικές επιπτώσεις της λίπανσης.

                    <p style="font-size: 30px;color:#000;" class="mt-8 mb-10">
                        Το <span class="green-text">NutriSense</span> είναι το μέλλον στη διαχείριση της υδρολίπανσης και το μέλλον ξεκινά τώρα!
                    </p>
                    <p>
                        Κάποια από τα πρακτικά πλεονεκτήματα της χρήσης του <span class="green-text">NutriSense</span>:
                        <ul>
                            <li>Βελτιώνει την απόδοση και την ποιότητα των προϊόντων των κηπευτικών καλλιεργειών παρέχοντας ακριβείς, συνθέσεις θρεπτικών διαλυμάτων για υδρολίπανση, εξατομικευμένες για κάθε καλλιέργεια.</li>
                            <li>Μειώνει το κόστος παραγωγής για τους καλλιεργητές παρέχοντας συνταγές θρεπτικών διαλυμάτων για λίπανση προσαρμοσμένες στις πραγματικές ανάγκες των φυτών.</li>
                            <li>Μειώνει τις περιβαλλοντικές επιπτώσεις της λίπανσης βελτιστοποιώντας την παροχή αζώτου και φωσφόρου, ελαχιστοποιώντας έτσι τη ρύπανση των υδάτινων πόρων λόγω έκπλυσης και απορροής.</li>
                            <li>Επιτρέπει την συνεχή προσαρμογή της λίπανσης στις τρέχουσες ανάγκες των φυτών, λαμβάνοντας υπόψη δεδομένα αναλύσεων εδάφους, θρεπτικών διαλυμάτων και φυτικών ιστών που πραγματοποιούνται κατά την διάρκεια της καλλιέργειας.</li>
                            <li>Παρέχει ένα πρακτικό και αποτελεσματικό εργαλείο σε καλλιεργητές και συμβούλους για τη διαχείριση της λίπανσης των καλλιεργειών τους με επιτυχία και ακρίβεια.</li>
                            <li>Μειώνει τις αρνητικές επιπτώσεις της λίπανσης στο περιβάλλον (π.χ. νιτρορύπανση) και βελτιώνει την κερδοφορία.</li>
                        </ul>
                        Έτοιμοι να ξεκινήσουμε;
                        <br>
                        <br>
                        <br>
                        <!-- Εάν δεν είστε χρήστης του <span class="green-text">NUTRISENSE</span>, μπορείτε να εγγραφείτε κάνοντας κλικ εδώ: Subscribe now
                        <br>
                        Εάν είστε χρήστης του <span class="green-text">NUTRISENSE</span>, μπορείτε να συνδεθείτε κάνοντας κλικ εδώ: Login here -->
                    </p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
        }
    }
</script>
<style scoped>
.heading {
    color: #5FA936;
    font-size: 36px;
    font-weight: 700;
}

.head-container{
    background-image: url("~@/assets/about_a_head.png");
    min-height: 250px;
    height: auto;
    padding: 40px 20px;
    width: 100%;
    z-index: 0;
    color: #fff;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-shadow: 0px 0px 20px #0304036b;
    margin-top: -50px;
}

.head-text-main {
    font-weight: 700;
    font-size: clamp(28px, 7vw, 96px);
}

.head-text-secondary {
    font-size: 32px;
}

.main-text {
    color: #646464;
    font-size: 16px;
    line-height: 26px;
}
.text-container {
    max-width: 90%;
}

.green-text {
    color: #006600;
    font-weight: bold;
}

@media (max-width: 960px) {
    .head-container {
        min-height: 200px;
    }
}

@media (max-width: 600px) {
    .head-container {
        padding: 30px 15px;
        min-height: 150px;
    }
}
</style>
